import React from 'react';
import { Button } from 'react-bootstrap';

// Manter sincronizado com ALLOWED_EXTENSIONS no backend
const ACCEPTED_EXTENSIONS = '.jpg,.jpeg,.bmp,.webm,.pdf,.mp4,.wmv,.avi';

const CustomFileInput = ({
  id,
  label,
  onChange,
  multiple,
  accept = ACCEPTED_EXTENSIONS,
}) => {
  const handleKeyDown = event => {
    if (event.key !== 'Enter' && event.key !== ' ') return;

    event.preventDefault();
    document.getElementById(id)?.click();
  };

  return (
    <div className="d-flex justify-content-center">
      <input
        accept={accept}
        id={id}
        type="file"
        className="d-none"
        multiple={multiple}
        onChange={onChange}
        aria-hidden="true"
        tabIndex={-1}
      />
      <Button
        as="label"
        htmlFor={id}
        variant="secondary"
        size="sm"
        tabIndex={0}
        aria-label={label}
        onKeyDown={handleKeyDown}
      >
        {label}
      </Button>
    </div>
  );
};

export default CustomFileInput;
